module.exports = __webpack_public_path__ + "img/zhAward-a.e32c4228.png";